import type { View } from 'cadenza/workbook/view/view';
import { ViewActionsToolbar } from 'cadenza/workbook/view/view-header/view-actions-toolbar';

import './content-view-toolbar.css';

const COMPONENT_NAME = 'd-content-view-toolbar';

/**
 * @implements {import('./worksheet-view-toolbar').IViewToolbar}
 */
export class ContentViewToolbar extends HTMLElement {
  readonly #view;

  constructor(view: View) {
    super();
    this.#view = view;
  }

  connectedCallback() {
    this.classList.add(COMPONENT_NAME);
    this.append(new ViewActionsToolbar(this.#view, { isContentView: true }));
  }

  update() {
    // nothing to do
  }
}

customElements.define(COMPONENT_NAME, ContentViewToolbar);
